import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { graphql, readInlineData } from "react-relay";

import { accountAtom } from "shared/lib/account";

import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";
import { currentArticleAtom } from "scmp-app/lib/current-item";
import type { commentHeaderFeaturesArticle$key } from "scmp-app/queries/__generated__/commentHeaderFeaturesArticle.graphql";

import IconComment from "./comment.svg";
import { Container, StyledArticleCommentsTrigger } from "./styles";

export type HeaderFeaturesCommentProps = {
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
  showOnSwap?: SwapCondition;
};

export const HeaderFeaturesComment: FunctionComponent<HeaderFeaturesCommentProps> = ({
  shouldSwap,
  showIn,
  showOnSwap,
}) => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  const currentArticle = useAtomValue(currentArticleAtom);
  if (!currentArticle || !isLoggedIn) return null;

  const article = readInlineData<commentHeaderFeaturesArticle$key>(
    graphql`
      fragment commentHeaderFeaturesArticle on Article @inline {
        ...articleCommentsTriggerArticle
      }
    `,
    currentArticle,
  );

  return (
    <Container $shouldSwap={shouldSwap} $showIn={showIn} $showOnSwap={showOnSwap}>
      <StyledArticleCommentsTrigger icon={<IconComment />} reference={article} variant="button" />
    </Container>
  );
};

HeaderFeaturesComment.displayName = "HeaderFeaturesComment";
